import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { PlansPage } from 'features/plans'
import { canViewBillingPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/plans')({
  component: PlansPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Plans'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})
